module.exports = __webpack_public_path__ + "static/media/Wipro PDP Summary of Benefits (1).doc.be4fcceb.pdf";